export default {
  colors: {
    orange: "#ff6000",
    lightOrange: "#ffeee3",
    red100: "#D65959",
    red200: "#f90000",
    black: "#000000",
    green: "#90d659",
    text: "#484848",
    gray100: "#eeeeee",
    gray200: "#e5e5e5",
    gray300: "#f1f1f1",
    gray400: "#cdcdcd",
    gray500: "#b0b0b0",
    gray600: "#9b9b9b",
    gray700: "#646464",
  },
  fonts: {
    default: "'Roboto', sans-serif",
  },
  fontSizes: {
    xs: "12px",
    sm: "14px",
    rg: "15px",
    md: "16px",
    lg: "28px",
  },
  shadows: {
    header: "0px 1px 1px rgba(0, 0, 0, 0.35)",
  },
};
